export const SIDE_PANEL_PORTAL_ID = 'side-panel-portal'
